import { mediaQuery, StyledP } from 'components';
import styled from 'styled-components';
import { StyledH3 } from './typography';

interface RelatedProductsProps {
  secondary?: boolean;
}

export const RelatedProductsContainer = styled.div<RelatedProductsProps>`
  margin: auto;
  padding: 1rem;
  line-height: 150%;
  max-width: 1180px;

  ${mediaQuery.medium`
    padding: 2rem 0.5rem;
  `}
`;

export const ProductBlockContainer = styled.div<RelatedProductsProps>`
  display: flex;    
    margin: 0 -8px;
    flex-wrap: wrap;

    > div {
      flex-grow: 1;
      margin: 8px;
      flex-basis: calc(50% - 16px);
      max-width: calc(50% - 16px);

      ${mediaQuery.medium`
          flex-basis: calc(33% - 16px);
          max-width: calc(33% - 16px);
      `};

      ${mediaQuery.large`
          flex-basis: calc(20% - 16px);
          max-width: calc(20% - 16px);
      `};
    }

    img {
        max-width: 100%;
        height: auto;
    }
`;

export const RelatedProductsTitle = styled(StyledH3)<RelatedProductsProps>`
  text-align: center;
  font-size: 1.375rem;;
`;

export const ProductBlockWrapper = styled.div`
  display: inline-flex;
  flex-direction: column;
  position: relative;
`;

export const ProductBadge = styled.div`
  z-index: 1;
  position: absolute;
  padding: 12px;

  ${mediaQuery.medium`
    padding: 16px;
  `};
`;

export const ProductDetailsWrapper = styled.div<RelatedProductsProps>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 15px 0;

  ${StyledP} {
    text-align: center;
    margin: 2px 0;
  }
`;
